import { Redirect } from 'aurelia-router';
/**
 * This container takes care of destroying the user session on the Olapic SSO.
 */
class LogoutContainer {
  /**
   * @param {Router}          router          To validate if the user can access the container or
   *                                          if he/she should be redirected to the home route.
   * @param {AppErrorHandler} appErrorHandler In case the sign out process fails.
   * @param {AppSession}      appSession      To actually invoke the sign out process.
   */
  constructor(router, appErrorHandler, appSession) {
    'inject';

    /**
     * A local reference for the `router` service.
     * @type {Router}
     * @access protected
     */
    this._router = router;
    /**
     * A local reference for the `appErrorHandler` service.
     * @type {AppErrorHandler}
     * @access protected
     */
    this._appErrorHandler = appErrorHandler;
    /**
     * A local reference for the `appSession` service.
     * @type {AppSession}
     * @access protected
     */
    this._appSession = appSession;
  }
  /**
   * Triggers the sign out process.
   */
  activate() {
    this._appSession.signout()
    .catch((error) => {
      this._appErrorHandler.handle(error);
    })
    .then(() => {
      this._router.navigateToRoute('home');
    });
  }
  /**
   * Validates if the user is not authenticated in order to prevent him/her from accessing the
   * container.
   * @return {Boolean|Redirect}
   */
  canActivate() {
    let result = true;
    if (!this._appSession.isAuthenticated()) {
      result = new Redirect('home');
    }

    return result;
  }
}

export { LogoutContainer };
